import { gql } from "graphql-request";

export const READ_TENANT_LEAVE_YEARS = gql`
  query ReadTenantLeaveYears($tenantID: ID!) {
    readTenantLeaveYears(tenantID: $tenantID) {
      id
      startDate
      endDate
      status
    }
  }
`;

export const READ_STAFF_WORK_PATTERNS = gql`
  query ReadStaffWorkPatterns(
    $tenantID: ID!
    $staffTenantUserID: ID!
    $leaveYearID: ID!
  ) {
    readStaffWorkPatterns(
      tenantID: $tenantID
      staffTenantUserID: $staffTenantUserID
      leaveYearID: $leaveYearID
    ) {
      id
      tenantID
      staffTenantUserID
      leaveYearID
      name
      effectiveFrom
      effectiveTo
      days {
        dayOfWeek
        isWorkingDay
        startTime
        endTime
        unpaidBreakMinutes
        scheduledMinutes
      }
    }
  }
`;